import { useRef, useState, useEffect } from "react";
import { TextField, Panel, DefaultButton } from "@fluentui/react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";

import styles from "./Chat.module.css";

import { chatApi, Approaches, ChatResponse, GptChatRequest, GptChatTurn } from "../../api";
import { AnswerChat, AnswerError, AnswerLoading } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { UserChatMessage } from "../../components/UserChatMessage";
import { SettingsButton } from "../../components/SettingsButton";
import { ClearChatButton } from "../../components/ClearChatButton";

import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const Chat = () => {
    const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // URLからの値を保持するためのState
    const [kname, setKname] = useState<string>("");
    const [site, setSite] = useState<string>("");



    const [gptModel, setGptModel] = useState<string>("gpt-3.5-turbo");
    const [systemPrompt, setSystemPrompt] = useState<string>("");
    const [temperature, setTemperature] = useState<string>("0.0");
    const [availableModels, setAvailableModels] = useState<Record<string, any>>({});

    const lastQuestionRef = useRef<string>("");
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>();

    const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
    const [answers, setAnswers] = useState<[user: string, response: ChatResponse][]>([]);

    useEffect(() => {



        const url_kname = searchParams.get("kname") || "";
        const url_site = searchParams.get("site") || "";
        if (url_kname) {
            // デバッグ用の alert
            alert("URLから次の値を取得しました: " + url_kname + "===" + url_site);

            // Stateに保存（これで画面がリロードされない限り値が保持される）
            setKname(url_kname);
            setSite(url_site);
        }
 

        // 修正：しっかり中身を波カッコ { } で囲んで、勝手に return されないようにします
        {

            fetch("/available_models")
                .then((response) => response.json())
                .then((data) => {


// ⭕ 安全対策：data が存在し、かつオブジェクトの時だけ処理する
                    if (data && typeof data === "object") {
                        const parsedData = Object.fromEntries(
                            Object.entries(data).map(([key, value]) => [key, value === true])
                        );
                        setAvailableModels(parsedData);
                    } else {
                        console.warn("available_models から予期せぬデータが返りました:", data);
                    }


//                    const parsedData = Object.fromEntries(
//                        Object.entries(data).map(([key, value]) => [key, value === true])
//                    );
//                    setAvailableModels(parsedData);





                })
                .catch((err) => {
                    console.error("Error fetching models:", err);
                });
        }

    }, []);
    
    const gpt_models: IDropdownOption[] = [
        { key: "gpt-3.5-turbo", text: "gpt-3.5-turbo" },
        { key: "gpt-4", text: "gpt-4" },
        { key: "gpt-4-global", text: "gpt-4-global" },
        { key: "gpt-4o", text: "gpt-4o" },
        { key: "gpt-4o-global", text: "gpt-4o-global" }
    ];

    const filteredGptModels: IDropdownOption[] =
    (availableModels && Object.keys(availableModels).length > 0)
        ? gpt_models.filter(option => availableModels[option.key])
        : gpt_models;

    const temperatures: IDropdownOption[] = Array.from({ length: 11 }, (_, i) => ({ key: (i / 10).toFixed(1), text: (i / 10).toFixed(1) }));

    const makeApiRequest = async (question: string, ceaflg: boolean = false ,url_kname?: string, url_site?: string) => {

        console.log("送信される値:", { url_kname, url_site }); // ブラウザのコンソールで確認

        lastQuestionRef.current = question;

        if (ceaflg) {
	  question = question + "ctlEnterAdd";
        }

        error && setError(undefined);
        setIsLoading(true);

        try {
            const history: GptChatTurn[] = answers.map(a => ({ user: a[0], assistant: a[1].answer }));
            const request: GptChatRequest = {
                history: [...history, { user: question, assistant: undefined }],
                approach: Approaches.Read,
                overrides: {
                    gptModel: gptModel,
                    temperature: temperature,
                    systemPrompt: systemPrompt
                },
		url_kname: url_kname,
		url_site: url_site
            };
            const result = await chatApi(request);
            setAnswers([...answers, [question, result]]);

        } catch (e) {
            console.error("Chat API Error:", e);

            if (
                e instanceof Error &&
                e.message === "CHAT_API_ERROR出力:500"
            ) {
                alert(
                    "サーバーでエラーが発生しました。\n" +
                    "TOP画面に戻ります。"
                );

                navigate("/");
                return;
            }

            setError(e);

        } finally {
            setIsLoading(false);
        }

//        } catch (e) {
//            setError(e);
//        } finally {
//            setIsLoading(false);
//        }
    };


    const clearChat = () => {
        lastQuestionRef.current = "";
        error && setError(undefined);
        setAnswers([]);
    };

//    useEffect(() => {
//        chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" }), [isLoading]);
//    }

    useEffect(() => {
        chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" });
    }, [isLoading]);


    const onGptModelChange = (_ev?: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option !== undefined) {
            setGptModel(option.key as string);
        }
    };

    const onSystemPromptChange = (_ev?: React.SyntheticEvent<HTMLElement, Event>, newValue?: string) => {
        setSystemPrompt(newValue || "");
    };

    const onTempertureChange = (_ev?: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option !== undefined) {
            setTemperature(option.key as string);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.commandsContainer}>
                <ClearChatButton className={styles.commandButton} onClick={clearChat} disabled={!lastQuestionRef.current || isLoading} />
                {/* <SettingsButton className={styles.commandButton} onClick={() => setIsConfigPanelOpen(!isConfigPanelOpen)} /> */}
            </div>
            <div className={styles.chatRoot}>
                <div className={styles.chatContainer}>
                    <div className={styles.chatMessageStream}>
                        {answers.map((answer, index) => (
                            <div key={index}>
                                <UserChatMessage message={answer[0]} />
                                <div className={styles.chatMessageGpt}>
                                    <AnswerChat key={index} answer={answer[1]} isSelected={selectedAnswer === index} />
                                </div>
                            </div>
                        ))}
                        {isLoading && (
                            <>
                                <UserChatMessage message={lastQuestionRef.current} />
                                <div className={styles.chatMessageGptMinWidth}>
                                    <AnswerLoading />
                                </div>
                            </>
                        )}
                        {error ? (
                            <>
                                <UserChatMessage message={lastQuestionRef.current} />
                                <div className={styles.chatMessageGptMinWidth}>
                                    <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                </div>
                            </>
                        ) : null}
                        <div ref={chatMessageStreamEnd} />
                    </div>

                    <div className={styles.chatInput}>
                        <QuestionInput
                            clearOnSend
                            placeholder="YG健康保険組合AIチャットへようこそ。 ご家族の加入や傷病手当金の申請、健康診断・健康増進サービスなど、健康保険に関するお問い合わせに24時間いつでもお答えします。ご質問を入力してください（英語・韓国語を含む10か国語対応。氏名・記号番号・マイナンバー等の個人情報は入力しないでください）"
                            disabled={isLoading}
                            onSend={(question: string, ceaflg?: boolean) => {makeApiRequest(question, ceaflg, kname, site);}}
                        />
                    </div>
                </div>
                <Panel
                    headerText="Configure GPT settings"
                    isOpen={isConfigPanelOpen}
                    isBlocking={false}
                    onDismiss={() => setIsConfigPanelOpen(false)}
                    closeButtonAriaLabel="Close"
                    onRenderFooterContent={() => <DefaultButton onClick={() => setIsConfigPanelOpen(false)}>Close</DefaultButton>}
                    isFooterAtBottom={true}
                >
                    <Dropdown
                        className={styles.chatSettingsSeparator}
                        defaultSelectedKeys={[gptModel]}
                        selectedKey={gptModel}
                        label="GPT Model:"
                        options={filteredGptModels}
                        onChange={onGptModelChange}
                    />
                    <TextField
                        className={styles.chatSettingsSeparator}
                        value={systemPrompt}
                        label="System Prompt:"
                        multiline
                        autoAdjustHeight
                        onChange={onSystemPromptChange}
                    />
                    <Dropdown
                        className={styles.chatSettingsSeparator}
                        defaultSelectedKeys={[temperature]}
                        selectedKey={temperature}
                        label="Temperature:"
                        options={temperatures}
                        onChange={onTempertureChange}
                    />
                </Panel>
            </div>
        </div>
    );
};

export default Chat;
